import React, { ReactElement } from 'react';
import { useDashboardsContainer } from 'adapter/in/dashboards/containers/Dashboards/useDashboardsContainer';
import HomeTable from 'adapter/in/common/components/HomeTable/HomeTable';
import { useDashboardsNameColumn } from 'adapter/in/dashboards/containers/Dashboards/DashboardsTable/hooks/useDashboardsNameColumn';

import { useDashboardsStarColumn } from 'adapter/in/dashboards/containers/Dashboards/DashboardsTable/hooks/useDashboardsStarColumn';
import { useDashboardAccessColumn } from 'adapter/in/dashboards/containers/Dashboards/DashboardsTable/hooks/useDashboardsAccessColumn';
import { useDashboardsActionsDropdownColumn } from 'adapter/in/dashboards/containers/Dashboards/DashboardsTable/hooks/useDashboardsActionsDropdownColumn';

type StarredDashboardsContainerProps = {
    debouncedSearchTerm?: string;
};

const DashboardsTableContainer = (props: StarredDashboardsContainerProps): ReactElement => {
    const { debouncedSearchTerm } = props;
    const { dashboards, error, isLoading, order, onTableChange } = useDashboardsContainer(debouncedSearchTerm);

    const { column: dashboardsStarColumn } = useDashboardsStarColumn();
    const { column: dashboardsNameColumn } = useDashboardsNameColumn(order);
    const hasPinnedDashboard = dashboards !== undefined && dashboards.some((dashboard) => dashboard.pinned);
    const { column: dashboardsActionsDropdownColumn } = useDashboardsActionsDropdownColumn(hasPinnedDashboard);
    const { column: dashboardAccessColumn } = useDashboardAccessColumn();
    return (
        <>
            <HomeTable
                dataSource={dashboards || null}
                columns={
                    dashboards ? [dashboardsStarColumn, dashboardsNameColumn, dashboardAccessColumn, dashboardsActionsDropdownColumn] : null
                }
                isLoading={isLoading && error === undefined}
                showError={error !== undefined}
                onChange={onTableChange}
            />
        </>
    );
};

export default DashboardsTableContainer;
